export default __webpack_public_path__ + "static/media/Gloves of the Ascension.c027b0da.jpg";